import { render, staticRenderFns } from "./DuelsUserElement.vue?vue&type=template&id=253b4073&scoped=true"
import script from "./DuelsUserElement.vue?vue&type=script&lang=js"
export * from "./DuelsUserElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsUserElement.vue?vue&type=style&index=0&id=253b4073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b4073",
  null
  
)

export default component.exports